/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateDefaultCoverPhotoSiteRequestFromJSON(json) {
    return UpdateDefaultCoverPhotoSiteRequestFromJSONTyped(json, false);
}
export function UpdateDefaultCoverPhotoSiteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        defaultImageId: !exists(json, 'default_image_id') ? undefined : json['default_image_id']
    };
}
export function UpdateDefaultCoverPhotoSiteRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        default_image_id: value.defaultImageId
    };
}
